import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { Icon } from '@iconify/react';
import { Grid, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import GetQuoteServices from '../../../redux/api/GetQuoteServices';
import {
  getConfirmQuoteMethod,
  getDeliverQuoteMethod,
  getPendingQuoteMethod,
  getQuoteMethod,
} from '../../../redux/slice/getQuoteSlice';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function AddGetQuoteRateDialog({ openAddForm, handleClickOpenAddForm, requestName, quoteId }) {
  const [rate, setRate] = React.useState(null);
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    if (!rate) {
      toast.error('Please Enter Rate');
      return;
    }
    const data = {
      rate,
      quoteId,
    };
    await GetQuoteServices.add(data)
      .then((res) => {
        console.warn('-----------------', res);
        toast.success('Add Get Quoate Rate Successfully');
        if (requestName === 'All') {
          dispatch(getQuoteMethod());
        } else if (requestName === 'Pending') {
          dispatch(getPendingQuoteMethod());
        } else if (requestName === 'Confirm') {
          dispatch(getConfirmQuoteMethod());
        } else if (requestName === 'Deliver') {
          dispatch(getDeliverQuoteMethod());
        }
        handleClickOpenAddForm();
      })
      .catch((error) => {
        if (!error.response.data.message) {
          toast.error(error.message, { position: 'top-right' });
        } else {
          toast.error(error.response.data.message, { position: 'top-right' });
        }
        throw error;
      });
  };
  return (
    <div>
      <Dialog fullScreen open={openAddForm} onClose={handleClickOpenAddForm} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', backgroundColor: '#70AD47' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClickOpenAddForm} aria-label="close">
              {/* <CloseIcon /> */}
              <Icon icon="ic:outline-close" />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Add Get Quote Rate
            </Typography>
            {/* <Button autoFocus variant='outlined' sx={{color:'white',borderColor:'white'}} onClick={handleSubmit}>
              Save
            </Button> */}
          </Toolbar>
        </AppBar>
        <Grid container spacing={2} sx={{ textAlign: 'left', padding: '3%' }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'center' }}>
            <Typography variant="h5">Add Get Quote Rate</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              Rate
            </Typography>
            <TextField
              id="outlined-basic"
              placeholder="Rate"
              variant="outlined"
              fullWidth
              type='number'
              onChange={(e) => setRate(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'left' }}>
            <Button
              autoFocus
              variant="contained"
              sx={{ color: 'white', borderColor: 'white', width: '10%' }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
